'use client';

/**
 * [DC01] Atomic component for displaying a progress bar
 */
interface ProgressBarProps {
  value: number; // Value between 0 and 100
  color?: string;
  height?: number;
  className?: string;
  animated?: boolean;
}

// Named export for better tree-shaking and explicit imports
export function ProgressBar({
  value,
  color = 'bg-green-500',
  height = 8,
  className = '',
  animated = false,
}: ProgressBarProps) {
  // [CP01] Simple component with minimal logic
  // [NS04] Conditional classes for animation
  const animationClass = animated ? 'transition-all duration-1000' : '';
  
  // Ensure value is between 0 and 100
  const safeValue = Math.max(0, Math.min(100, value));
  
  return (
    <div 
      className={`w-full bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden ${className}`} 
      style={{ height: `${height}px` }}
    >
      <div
        className={`${color} ${animationClass} rounded-full`}
        style={{ 
          width: `${safeValue}%`,
          height: '100%'
        }}
      />
    </div>
  );
}
